<template>
    <div>
        <v-container>
            <v-row class="ma-0">
                <v-col cols="7" class="text-right">
                    <span class="headline text-center">Paket Lelang Tahun Anggaran </span>
                </v-col>
                <v-col cols="2">
                    <v-select label="Tahun Anggaran" class="headline" v-model="selectedTahunAnggaran" :items="listTahunAnggaran" single-line dense @change="tahunAnggaranChanged()" />
                </v-col>
            </v-row>
            <v-row class="mx-2">
                <v-col cols="2"></v-col>
                <v-col cols="10">
                    <v-text-field label="Search" v-model="search" append-icon="search" single-line hide-details clearable />
                </v-col>
            </v-row>

            <!-- DATA TABLE -->
            <v-row class="ma-0">
                <v-col>
                    <v-data-table class="elevation-1" :headers="table.headers" :items="table.items" :items-per-page="10" no-data-text="Tidak ada revisi jadwal">
                        
                        <!-- PPK -->
                        <template v-slot:item.ppk="{item}">
                            {{ getPPKText(item.ppk) }}
                        </template>

                        <!-- Status -->
                        <template v-slot:item.statusPelaksanaan="{item}">
                            <v-chip :color="getColorStatus(item.statusPelaksanaan)">
                                {{ getStatusPelaksanaan(item.statusPelaksanaan) }}
                            </v-chip>
                        </template>

                        <!-- Actions -->
                        <template v-slot:item.actions="{item}">
                            <v-btn v-if="item.statusPelaksanaan !== 'S'" color="blue" small icon @click="openForm(item)"> <v-icon small class="mr-2">mdi-calendar-edit</v-icon> </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

        </v-container>

        <!-- DIALOG -->
        <v-dialog v-model="form.isShowing" max-width="80%" persistent>
                <v-card>
                    <v-card-text>
                        <v-tabs v-model="tab" fixed-tabs background-color="indigo" dark show-arrows center-active slider-color="yellow">
                            <v-tab>Informasi</v-tab>
                            <v-tab>Approve Jadwal</v-tab>
                            <v-tabs-items v-model="tab">
                                <v-tab-item> <PreviewLelang user /> </v-tab-item>
                                <v-tab-item> 
                                    <RevisiJadwal v-if="form.paket" 
                                        :paketId="form.paket.id" 
                                        :paketKode="form.paket.kode" 
                                        :paketName="form.paket.nama" 
                                        :btnTutup="false"
                                        :btnSimpan="false"
                                        btnApprove
                                        @submitted="jadwalApproved"
                                    /> 
                                </v-tab-item>
                            </v-tabs-items>
                        </v-tabs>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="cyan" dark @click="closeForm()">Tutup</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

        <!-- Notification -->
        <v-snackbar
                v-model="notification.show"
                :color="notification.color"
                :timeout=3000
                top
                right
        >
            {{ notification.text }}
        </v-snackbar>

    </div>
</template>


<script>

const apiUrl = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;
import { tahunAnggaran, itemsPPKPengadaan } from './../../lib/viewLib'
import { getJadwalLelang } from './../../lib/viewTenderLib'
import PreviewLelang from "./../../components/lelang/PreviewLelang"
import RevisiJadwal from "./../../components/lelang/UserUpdateJadwal"



export default {
    components: {
        PreviewLelang, 
        RevisiJadwal
    },

    data() {
        return {
            listTahunAnggaran: tahunAnggaran,
            listPPK: itemsPPKPengadaan,
            selectedTahunAnggaran: "",
            search: "",

            table: {
                headers: [
                    { text: "Kode", value: "kode" },
                    { text: "Nama Paket", value: "nama" },
                    { text: "PPK", value: "ppk" },
                    { text: "Status", value: "statusPelaksanaan" },
                    { text: "Actions", value: "actions", sortable: false }
                ],
                items: []
            },

            form: {
                paket: null,
                listJadwal: [],
                isShowing: false
            },

            tab: null,

            notification: {
                show: false,
                color: "success",
                text: ""
            }
        }

    }, // data


    created() {
        this.selectedTahunAnggaran = this.$store.getters.tahunAnggaran;
        this.getData();
    },


    methods: {
        getData() {
            axios.get(`${apiUrl}/api/rup/jadwal/revisi/paket/${this.selectedTahunAnggaran}`)
            .then( (response) => {
                this.table.items = response.data;
            }).catch( (error) => {
                console.error(error);
            });
        },

        tahunAnggaranChanged() {
            this.getData();
        },

        getPPKText(val) {
            return this.listPPK.find(element => { return element.value === val; }).text;
        },

        getColorStatus: function(data) {
            let caption =''
            switch (data) {
                case 'S':
                    caption = 'success'
                    break
                case 'P':
                    caption = 'warning'
                    break
                case 'G':
                case 'U':
                    caption = 'error'
                    break
                default:
                    caption = 'info'
            }
            return caption
        },

        getStatusPelaksanaan: function(data) {
            let caption =''
            switch (data) {
                case 'A':
                    caption = 'Aktif'
                    break
                case 'S':
                    caption = 'Selesai'
                    break
                case 'G':
                    caption = 'Gagal'
                    break
                case 'U':
                    caption = 'Ulang'
                    break
                case 'P':
                    caption = 'Pending'
                    break
                default:
                    caption = 'Baru'
            }
            return caption
        },

        closeForm() {
            this.form.paket = null;
            this.form.listJadwal = [];
            this.form.isShowing = false;
        },

        async openForm(paket) {
            if (paket) {
                this.form.paket = Object.assign({}, paket);
                this.form.listJadwal = await getJadwalLelang(paket.id);

                this.$store.dispatch('lelang/assignPaket', paket);
                this.$store.dispatch('lelang/assignJadwal', this.form.listJadwal);

                this.form.isShowing = true;
            }
        },

        jadwalApproved(success) {
            if (success) {
                this.closeForm();
                this.getData();

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Revisi jadwal berhasil di-approve"
                };
            }
        }

    }, // methods
}

</script>